<template>
  <div>
    <el-drawer :wrapperClosable="false" :visible.sync="ruleDialogVisble" size="620px" :show-close="false" destroy-on-close>
      <template #title>
        <div style="height: 50px">
          <drawer-header :title="ruleDialogTitle" :is-add="true" :subLoading="submitLoading" @close="handleClose"
                         @confirm="handleSubmit"/>
        </div>
      </template>
      <div style="padding:0 20px;">
        <el-alert v-show="rulesForm.id && userRuleInfo" :title="userRuleInfo" type="warning" :closable="false"
                  style="margin: 5px;"/>
        <el-form :model="rulesForm" ref="rulesFormRef" :rules="rules">
          <el-row>
            <el-col>
              <el-form-item label="规则名称" prop="name">
                <el-input v-model="rulesForm.name"/>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="是否启用" prop="status">
                <el-switch v-model="rulesForm.status" :active-value="1" :inactive-value="0"/>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" rows="2" v-model="rulesForm.remark"/>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="规则高于节假日" prop="priorityHolidays">
                <el-checkbox v-model="rulesForm.priorityHolidays"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" style="margin-bottom: 10px;width: 100%">
              <el-tabs v-model="activeName" :stretch="true">
                <el-tab-pane v-for="(item, index) in rulesForm.rules" :key="'rules_'+index" :label="formatterDay(index)" :name="index">
                  <el-card shadow="never">
                    <template #header>
                      <el-row>
                        <el-col :span="12">
                          <div class="card-header">
                            <span>{{ formatterDay(index) }}</span>
                            <el-tooltip class="item" effect="dark" content="复制到" placement="top">
                              <i class="el-icon-document-copy" @click="copeRule(index)" style="margin-left: 10px;cursor: pointer"></i>
                            </el-tooltip>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div style="text-align: right;">
                            全天
                            <el-switch v-model="item.isFullDay"
                                       @change="(val) =>hanldeFullDay(val,item)"/>
                          </div>
                        </el-col>
                      </el-row>
                    </template>
                    <div style="overflow-y: auto; height: 130px;">
                      <el-form-item v-for="(rule, ruleIndex) in item.intervals" :key="`time_rule_item_${index}_${ruleIndex}`" label="规则时段" style="margin-bottom: 0px ; white-space: nowrap;">
                        <el-time-picker style="width:calc(100% - 105px)"
                                        is-range :key="`time_rule_picker_${index}_${ruleIndex}`"
                                        size="medium"
                                        :disabled="item.isFullDay"
                                        v-model="item.intervals[ruleIndex]"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        start-placeholder="开始时间"
                                        range-separator="~"
                                        end-placeholder="结束时间"/>
                        <!-- @blur="(arr) => changeTime(arr,item,index)" -->
                        <el-link type="primary" style="margin-left: 5px; margin-bottom: 5px;"
                                 v-if="item.intervals.length !== 6 && ruleIndex == 0  && !item.isFullDay"
                                 @click="hanldeAddRule(item)">添加
                        </el-link>
                        <el-link type="danger" style="margin-left: 5px;margin-bottom: 5px;"
                                 v-if="item.intervals.length !== 1 && ruleIndex !== 0"
                                 @click="hanldeDeleteRule(item,ruleIndex)">删除
                        </el-link>
                      </el-form-item>

                    </div>
                  </el-card>
                </el-tab-pane>
              </el-tabs>

            </el-col>
          </el-row>
        </el-form>
      </div>

    </el-drawer>

    <el-dialog title="复制规则" :visible.sync="copeDialogVisible"  width="30%">
      <div style="padding: 20px 30px;">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group style=" display: grid;grid-template-columns: repeat(4, 1fr); grid-auto-rows: minmax(20px, auto);gap: 10px;" v-model="checkedWeeks" @change="handleCheckedWeeksChange">
          <el-checkbox v-for="week in weeks" :label="week.value" :key="week.value">{{week.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="text-align: center;">
        <el-button @click="copeDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="submitCopeRule">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DrawerHeader from "@/components/drawerHeader.vue"
import {
  validRuleTime
} from "@/views/nexus/validRule"
import {
  TimeRuleApi
} from "@/api/nexus/timeRule"
import setting from "@/views/account/setting.vue";
export default {
  components: {
    DrawerHeader
  },
  props: {
    id: ''
  },
  data() {
    return {
      activeName: 'sun',
      //dialog参数
      ruleDialogTitle: '',
      ruleDialogVisble: false,
      submitLoading: false,
      //表单规则
      rules: {
        name: {
          required: true,
          message: '请输入规则名称',
          trigger: 'blur'
        }
      },
      //表单对象
      rulesForm: {},
      //规则使用用户每字和数量
      userRuleInfo: '',
      copeDialogVisible: false,
      copeRuleDay: '',
      checkAll: false,
      checkedWeeks: [],
      weeks: [
          {value:'sun', label: '星期天'},
          {value:'mon', label: '星期一'},
          {value:'tue', label: '星期二'},
          {value:'wed', label: '星期三'},
          {value:'thu', label: '星期四'},
          {value:'fri', label: '星期五'},
          {value:'sat', label: '星期六'}
      ],
      isIndeterminate: false
    }
  },
  methods: {
    //提交
    async handleSubmit() {
      this.submitLoading = true;
      this.$refs.rulesFormRef.validate(async valid => {
        if (valid) {
          let rulesArr = Object.values(this.rulesForm.rules);
          //验证每个星期的规则
          // for (const [index, obj] of rulesArr.entries()) {
          //   //console.log("rulesArr", obj)
          //   //console.log("this.rulesForm.rules", Object.keys(this.rulesForm.rules)[index])
          //
          //   let bool = validRuleTime(obj.intervals);
          //   if (!bool) {
          //     let day = this.formatterDay(Object.keys(this.rulesForm.rules)[index]);
          //     this.$message.error(day.concat("的规则时段配置错误，开始时间必须大于上一段的结束时间"));
          //     return false;
          //   }
          // }
          let {
            code,
            message
          } = await TimeRuleApi.regulationSave(this.rulesForm)
          if (code == 200) {
            this.$message.success("操作成功");
            this.ruleDialogVisble = false;
            //父组件刷新
            this.$emit("on-load")
          } else {
            this.$message.error(message);
          }
        }
      })
      this.submitLoading = false;
    },
    //关闭抽屉
    handleClose() {
      this.ruleDialogVisble = false;
    },
    //打开抽屉
    async show(title) {
      this.ruleDialogTitle = title
      if (!this.id) {
        this.initRulesForm();
        this.ruleDialogVisble = true
      } else {
        let {
          code: ruleCode,
          data: ruleData
        } = await TimeRuleApi.getById(this.id)
        if (ruleCode == 200) {
          this.rulesForm = Object.assign({}, ruleData)
          let {
            code: userRuleCode,
            data: userRuleData
          } = await TimeRuleApi.getRegulationUserRuleInfo(this.id)
          if (userRuleCode == 200 && userRuleData) {
            this.userRuleInfo = userRuleData.names.concat("。用户数：", userRuleData.count)
          }
          this.ruleDialogVisble = true
        } else {
          this.$message.error("修改失败，重新编辑")
        }
      }

    },
    //规则显示星期格式化
    formatterDay(index) {
      switch (index) {
        case "mon":
          return "星期一";
        case "tue":
          return "星期二";
        case "wed":
          return "星期三";
        case "thu":
          return "星期四";
        case "fri":
          return "星期五";
        case "sat":
          return "星期六";
        case "sun":
          return "星期天";
      }
    },
    //开启全天
    hanldeFullDay(val, obj) {
      if (val) {
        obj.intervals.splice(0);
        obj.intervals.push(["00:00", "23:59"]);
      }
    },
    //验证当前操作的星期时段
    // changeTime(val, obj, index) {
    //   let bool = validRuleTime(obj.intervals);
    //   if (!bool) {
    //     let day = this.formatterDay(index);
    //     this.$message.error(day.concat("的规则时段配置错误，开始时间必须大于上一段的结束时间"))
    //   }
    // },
    //添加时段
    hanldeAddRule(obj) {
      obj.intervals.push(["00:00", "23:59"]);
    },
    //删除规则时段
    hanldeDeleteRule(obj, index) {
      obj.intervals.splice(index, 1)
    },
    //初始化表单
    initRulesForm() {
      let form = {
        name: '',
        status: 1,
        priorityHolidays: false,
        remark: '',
        rules: {
          sun: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          mon: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          tue: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          wed: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          thu: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          fri: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          },
          sat: {
            isFullDay: false,
            intervals: [
              [
                "00:00",
                "23:59"
              ]
            ]
          }
        }
      };
      this.rulesForm = Object.assign({}, form)
    },
    // 拷贝规则
    copeRule(day){
      this.copeRuleDay = day;
      this.checkAll = false;
      this.checkedWeeks = [];
      this.isIndeterminate = false;
      this.copeDialogVisible = true;
    },
    submitCopeRule(){
      let rule = this.rulesForm.rules[this.copeRuleDay];
      if(this.checkedWeeks.length > 0){
        this.checkedWeeks.forEach(week => {
          if(week != this.copeRuleDay){
            this.rulesForm.rules[week] = rule;
          }
        });
        console.info('this.rulesForm.rules__',this.rulesForm.rules);
        this.$message.success("复制成功");
        this.copeDialogVisible = false;
      }else{
        this.$message.warning("请选择要复制的星期");
      }
    },
    handleCheckAllChange(val) {
      this.checkedWeeks = val ? this.weeks.map(week => week.value) : [];
      this.isIndeterminate = false;
    },
    handleCheckedWeeksChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.weeks.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
    }
  }
}
</script>

<style>
::v-deep .el-time-picker__input { pointer-events: none; }

</style>